export default __webpack_public_path__ + "static/esencja-1aa63c0a1f143049b861ee5ab9a03d86.png";